var exports = {
  "o": "xae11d333--c55255--content-wrapper",
  "p": "xae11d333--c55255--list",
};

module.exports = exports;
